var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "352032_attach_file_icon 1",
    clipPath: "url(#clip0_7775_1453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.62516 3.49992V10.2083C9.62516 11.4974 8.581 12.5416 7.29183 12.5416C6.00266 12.5416 4.9585 11.4974 4.9585 10.2083V2.91659C4.9585 2.11159 5.61183 1.45825 6.41683 1.45825C7.22183 1.45825 7.87516 2.11159 7.87516 2.91659V9.04158C7.87516 9.36242 7.61558 9.62492 7.29183 9.62492C6.96808 9.62492 6.7085 9.36242 6.7085 9.04158V3.49992H5.8335V9.04158C5.8335 9.84659 6.48683 10.4999 7.29183 10.4999C8.09683 10.4999 8.75016 9.84659 8.75016 9.04158V2.91659C8.75016 1.62742 7.706 0.583252 6.41683 0.583252C5.12766 0.583252 4.0835 1.62742 4.0835 2.91659V10.2083C4.0835 11.9816 5.52141 13.4166 7.29183 13.4166C9.06225 13.4166 10.5002 11.9816 10.5002 10.2083V3.49992H9.62516Z",
    fill: "#F42E33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7775_1453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachRed);
export default __webpack_public_path__ + "static/media/attachRed.7e9c6408b5332ca8be1d11ee39f47844.svg";
export { ForwardRef as ReactComponent };